// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Zk-z","zenCrossSiteLabel":"_k-z","vrsnlCrossSiteLabel":"al-z"};